var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('course-list',{attrs:{"title":"Курсы, где я преподаю","params":{    'search[teacher]': _vm.userData.id  }}})}
var staticRenderFns = []

export { render, staticRenderFns }